module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-42.b82593ec.jpg";